// User CSS is injected via a <style> element's textContent, so it cannot break out into
// HTML. What remains risky is CSS that loads or runs things: @import, legacy script hooks
// (expression(), behavior, -moz-binding) and url() pointing anywhere unexpected
// (tracking beacons, javascript:). Those are removed; everything else is kept.

export const MAX_CUSTOM_CSS = 20_000;

const SAFE_URL = /^(https:\/\/|data:image\/(png|jpe?g|gif|webp|svg\+xml|avif)[;,])/i;

export function sanitizeCss(input: string): string {
  let css = input.slice(0, MAX_CUSTOM_CSS);

  // Normalise CSS escapes (e.g. \69mport) and control chars that could disguise keywords.
  css = css.replace(/\\([0-9a-f]{1,6})\s?/gi, (_m, hex: string) => {
    const code = parseInt(hex, 16);
    return code > 0 && code < 0x110000 ? String.fromCodePoint(code) : '';
  });
  css = css.replace(/\\(.)/g, '$1');
  css = css.replace(/[\u0000-\u0008\u000b\u000e-\u001f\u007f]/g, '');
  css = css.replace(/<\/?\s*style/gi, '');

  css = css.replace(/@import[^;]*;?/gi, '/* @import removed */');
  css = css.replace(/@namespace[^;]*;?/gi, '');
  css = css.replace(/expression\s*\(/gi, 'removed(');
  css = css.replace(/(-moz-binding|behavior)\s*:/gi, 'removed:');
  css = css.replace(/javascript\s*:/gi, 'removed:');

  css = css.replace(/url\(\s*(['"]?)(.*?)\1\s*\)/gi, (_m, _q: string, target: string) =>
    SAFE_URL.test(target.trim()) ? `url("${target.trim().replace(/"/g, '%22')}")` : 'none',
  );
  // image-set()/src() can also fetch – only allow them with the url() forms validated above.
  css = css.replace(/\b(image-set|src)\s*\(\s*(['"])(?!https:\/\/)[^'"]*\2/gi, '$1(none');

  return css;
}
